module.exports = __webpack_public_path__ + "static/media/nato_strap_grey_canvas.168b678b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nato_strap_grey_canvas.png
// module id = 116
// module chunks = 0